/**
 * @class reportAnnotationConstants
 */
import { tableConstantsFactory } from './tableConstantsFactory';
const prefix = 'REPORTANNOTATION';
const reportAnnotationConstants = tableConstantsFactory(prefix);
reportAnnotationConstants.CREATE_INFO = `${prefix}_CREATE_INFO`;
reportAnnotationConstants.CREATE_FREETEXT = `${prefix}_CREATE_FREETEXT`;
reportAnnotationConstants.CREATE_HIGHLIGHT = `${prefix}_CREATE_HIGHLIGHT`;
reportAnnotationConstants.CREATE_INK = `${prefix}_CREATE_INK`;
reportAnnotationConstants.CREATE_LINE = `${prefix}_CREATE_LINE`;
reportAnnotationConstants.CREATE_ISSUE = `${prefix}_CREATE_ISSUE`;
reportAnnotationConstants.RESET = `${prefix}_RESET`;
reportAnnotationConstants.DELETE_SUCCESS = `${prefix}_DELETE_SUCCESS`;
reportAnnotationConstants.DELETE_FAILURE = `${prefix}_DELETE_FAILURE`;
reportAnnotationConstants.SELECT_BY_TYPE_ID = `${prefix}_SELECT_BY_TYPE_ID`;
export default reportAnnotationConstants;